import _ from "lodash";
import React, { useState } from "react";
import { connect } from "react-redux";
import bindActions from "../../helpers/bindActions";
import { formHandlers } from "../../helpers/ConsentFormHandlers";
import * as patientRegisterActions from "../../actions/patientRegisterActions";
import questionTypeCodes from "../../constants/chart-sidebar/questionTypeCodes";

import {
  RadioList,
  ValueInput,
  CheckboxList,
  ValueRadioList,
  QuestionDatePicker,
} from "./QuestionFormFields";

const questionInputMap = {
  [questionTypeCodes.VALUE]: ValueInput,
  [questionTypeCodes.RADIO_LIST]: RadioList,
  [questionTypeCodes.CHECKBOX_LIST]: CheckboxList,
  [questionTypeCodes.DATE_PICKER]: QuestionDatePicker,
  [questionTypeCodes.VALUE_RADIO_LIST]: ValueRadioList,
};

const PatientFormsTemplateQuestions = ({ questions, patientRegisterActions }) => {
  const { changeFormQuestionAnswers } = patientRegisterActions;

  const getAnswers = (question) => {
    if (question.answers && question.answers.length) return question.answers;

    return question?.defaultAnswers || [];
  };

  const initState = (questions = []) => {
    const otherValues = {};
    const selectedOther = {};

    questions.forEach((question) => {
      const answers =
        question.answers && question.answers.length
          ? question.answers
          : question?.defaultAnswers || [];
      const typeCode = _.get(question, "questionType.code");
      const knownValues = question.values || [];

      if (typeCode === questionTypeCodes.CHECKBOX_LIST) {
        const otherAnswer = answers.find((answer) => !knownValues.includes(answer));
        otherValues[question.id] = otherAnswer || "";
      } else if (
        typeCode === questionTypeCodes.RADIO_LIST ||
        typeCode === questionTypeCodes.VALUE_RADIO_LIST
      ) {
        const val = answers[0] || "";
        if (val && !knownValues.includes(val)) {
          selectedOther[question.id] = true;
          otherValues[question.id] = val;
        }
      }
    });

    return { otherValues, selectedOther };
  };
  const [state, setState] = useState(() => initState(questions));
  const { otherValues, selectedOther } = state;
  const handlers = formHandlers(getAnswers, otherValues, setState, changeFormQuestionAnswers);

  if (!questions?.length) return null;

  return (
    <div className="patient-forms-template">
      {questions.map((question) => {
        const FormComponent = questionInputMap[_.get(question, "questionType.code")];
        return (
          <div key={question.id} className="patient-forms-template-question">
            <div className="question-label">
              <strong>{question.question}</strong>
            </div>
            {FormComponent && (
              <FormComponent
                question={question}
                answers={getAnswers(question)}
                otherValues={otherValues}
                selectedOther={selectedOther}
                handlers={handlers}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

const enhancer = connect(null, bindActions({ patientRegisterActions }));
export default enhancer(PatientFormsTemplateQuestions);
